var map = {
	"./apply.svg": "./icons/apply.svg",
	"./arrow.svg": "./icons/arrow.svg",
	"./bag.svg": "./icons/bag.svg",
	"./bls-connect.svg": "./icons/bls-connect.svg",
	"./calendar.svg": "./icons/calendar.svg",
	"./caret.svg": "./icons/caret.svg",
	"./carousel-arrow.svg": "./icons/carousel-arrow.svg",
	"./carousel-pause.svg": "./icons/carousel-pause.svg",
	"./carousel-play.svg": "./icons/carousel-play.svg",
	"./chat.svg": "./icons/chat.svg",
	"./check.svg": "./icons/check.svg",
	"./checkbox-checked.svg": "./icons/checkbox-checked.svg",
	"./clear.svg": "./icons/clear.svg",
	"./clock.svg": "./icons/clock.svg",
	"./contact.svg": "./icons/contact.svg",
	"./court.svg": "./icons/court.svg",
	"./cross.svg": "./icons/cross.svg",
	"./cv.svg": "./icons/cv.svg",
	"./directions.svg": "./icons/directions.svg",
	"./email-simple.svg": "./icons/email-simple.svg",
	"./email.svg": "./icons/email.svg",
	"./envelope.svg": "./icons/envelope.svg",
	"./facebook.svg": "./icons/facebook.svg",
	"./fax.svg": "./icons/fax.svg",
	"./flickr.svg": "./icons/flickr.svg",
	"./give.svg": "./icons/give.svg",
	"./instagram.svg": "./icons/instagram.svg",
	"./link-external.svg": "./icons/link-external.svg",
	"./linkedin.svg": "./icons/linkedin.svg",
	"./location.svg": "./icons/location.svg",
	"./logo-icon.svg": "./icons/logo-icon.svg",
	"./logo.svg": "./icons/logo.svg",
	"./map.svg": "./icons/map.svg",
	"./pdf.svg": "./icons/pdf.svg",
	"./phone.svg": "./icons/phone.svg",
	"./play.svg": "./icons/play.svg",
	"./pointer.svg": "./icons/pointer.svg",
	"./quote.svg": "./icons/quote.svg",
	"./safety.svg": "./icons/safety.svg",
	"./seal.svg": "./icons/seal.svg",
	"./search.svg": "./icons/search.svg",
	"./sms.svg": "./icons/sms.svg",
	"./sticky-note.svg": "./icons/sticky-note.svg",
	"./twitter.svg": "./icons/twitter.svg",
	"./website.svg": "./icons/website.svg",
	"./youtube.svg": "./icons/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./icons sync recursive \\.svg$";